export const UPDATE_SHOW_CAMERA_OFF_PARTICIPANTS = 'IISIGHT_UPDATE_SHOW_CAMERA_OFF_PARTICIPANTS';
